import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
    body{
    font-family: 'Inter', sans-serif;
    width: 100%;
    margin: 0;
    }
    p,h1,h2,h3,h4,h5,h5{
    padding: 0;
    margin: 0;
}

`;